import React, { memo } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { useSnapshot } from 'valtio';
import { editorState } from './editor-state';

const SystemPromptPanel = memo(() => {
  const { system } = useSnapshot(editorState.prompts);

  return (
    <div className="flex flex-col h-full">
      <h3 className="font-semibold mb-2">System Prompt</h3>
      <Textarea
        className="flex-1 w-full resize-none rounded-md border border-gray-200 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
        placeholder="Enter system prompt..."
        value={system}
        onChange={(e) => editorState.prompts.system = e.target.value}
      />
    </div>
  );
});

SystemPromptPanel.displayName = 'SystemPromptPanel';

export { SystemPromptPanel };